if (!customElements.get('native-share')) {
  customElements.define(
    'native-share',
    class NativeShare extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.handleClick = this.handleClick.bind(this);

        const shareData = this.getShareData();
        if (!this.canShare(shareData)) return;

        this.hidden = false;
        this.button.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }

      getShareData() {
        const shareUrl = new URL(this.button.dataset.shareUrl || window.location.href, document.baseURI);
        const currentUrl = new URL(window.location.href);
        const variantId = currentUrl.searchParams.get('variant');

        shareUrl.search = '';
        shareUrl.hash = '';
        if (variantId) shareUrl.searchParams.set('variant', variantId);

        return {
          title: this.button.dataset.shareTitle || document.title,
          url: shareUrl.toString(),
        };
      }

      canShare(shareData) {
        if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') return false;

        try {
          return typeof navigator.canShare !== 'function' || navigator.canShare(shareData);
        } catch (_error) {
          return false;
        }
      }

      async handleClick() {
        const shareData = this.getShareData();

        if (!this.canShare(shareData)) {
          this.hidden = true;
          return;
        }

        this.button.disabled = true;

        try {
          await navigator.share(shareData);
        } catch (error) {
          if (error?.name === 'AbortError') return;
        } finally {
          this.button.disabled = false;
        }
      }
    }
  );
}
